import { render } from "./OplAuthorizationTable.vue?vue&type=template&id=e9d45dc8"
import script from "./OplAuthorizationTable.vue?vue&type=script&lang=js"
export * from "./OplAuthorizationTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__